import Reveal from "../Reveal";
import { process } from "../../data/site";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32 border-t border-[#2E2E38]"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 mb-12 md:mb-16">
            <div className="md:col-span-4">
              <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.25em] text-[#E3FF34]">
                [ How we work ]
              </p>
            </div>
            <div className="md:col-span-8">
              <h2
                data-testid="process-heading"
                className="font-['Outfit'] font-medium tracking-tight text-4xl md:text-5xl lg:text-6xl text-[#F2F2F2]"
              >
                Four steps.{" "}
                <span className="text-[#A3A3A3]">No fluff. No politics.</span>
              </h2>
            </div>
          </div>
        </Reveal>

        <div className="border-t border-[#2E2E38]">
          {process.map((p, i) => (
            <Reveal key={p.no} delay={i * 0.05}>
              <div
                data-testid={`process-row-${p.no}`}
                className="group grid grid-cols-12 gap-4 md:gap-10 items-center border-b border-[#2E2E38] py-8 md:py-12 px-2 hover:bg-[#13131A] hover:px-6 transition-all duration-500"
              >
                <div className="col-span-3 md:col-span-2">
                  <span className="font-['Anton'] text-5xl md:text-7xl lg:text-8xl text-[#2E2E38] group-hover:text-[#E3FF34] transition-colors duration-500">
                    {p.no}
                  </span>
                </div>
                <div className="col-span-9 md:col-span-4">
                  <h3 className="font-['Outfit'] text-2xl md:text-3xl lg:text-4xl text-[#F2F2F2] tracking-tight group-hover:translate-x-2 transition-transform duration-500">
                    {p.title}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-6">
                  <p className="font-['Outfit'] font-light text-[#A3A3A3] text-base md:text-lg leading-relaxed">
                    {p.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
